var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: false, expression: "false" },
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "PrescriptionModal__container common-modal",
          class: _vm.className,
          attrs: { id: _vm.id },
        },
        [
          _c(
            "div",
            { staticClass: "PrescriptionModal__container__closeContainer" },
            [
              _vm.title
                ? _c(
                    "div",
                    { staticClass: "PrescriptionModal__container__title" },
                    [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "PrescriptionModal__container__close",
                  attrs: { id: "closeModal" },
                },
                [
                  _vm.isMobile
                    ? _c("span", { class: _vm.closeIconMobileClass })
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "PrescriptionModal__container__infoModalBody" },
            [_vm._t("content")],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }